export default "__VITE_ASSET__b56bacdb__"